/*
 * MedPraxora - B2B-Bestaetigung vor dem Checkout.
 *
 * Shopify Basic erlaubt keine eigenen Felder im Checkout. Deshalb sitzt die
 * Pflicht-Checkbox vor dem Checkout: Dieses Skript setzt sie in den Warenkorb
 * (ueber den Kasse-Button) und in den Mini-Warenkorb ein, auch nachdem das
 * Theme diese per AJAX neu aufgebaut hat. Eingebunden ueber
 * snippets/mp-b2b.liquid (aus snippets/header-scripts.liquid).
 *
 * Jeder Weg zur Kasse (Link oder Button) wird hier abgefangen:
 *
 *   - Checkbox angehakt  -> Bestaetigung als Warenkorb-Attribut speichern
 *                           (erscheint in der Bestellung unter "Zusaetzliche
 *                           Details") und weiter zur Kasse.
 *   - Checkbox leer      -> Hinweis anzeigen, nicht weiterleiten.
 *   - keine Checkbox da  -> Bestaetigungsfenster mit derselben Checkbox.
 */
(function () {
  'use strict';

  if (window.__medpraxoraB2B) return;
  window.__medpraxoraB2B = true;

  var KEY = 'B2B-Bestätigung';
  var TEXT =
    'Ich bestätige, dass ich als Unternehmer im Sinne von § 14 BGB ' +
    '(z. B. Arzt- oder Zahnarztpraxis, Klinik, Labor, Pflegeeinrichtung, Gewerbebetrieb) ' +
    'bestelle und nicht als Verbraucher. MedPraxora liefert ausschließlich an gewerbliche Kunden.';

  var TRIGGER =
    'a[href*="/checkout"], button[name="checkout"], input[name="checkout"], .btn_checkout, .cms-btn-check';

  var busy = false;
  var confirmed = false;

  // Wo die Checkbox hingehoert: Container -> Element, vor dem sie steht.
  var SLOTS = [
    ['.cart-total .group-button', '.btn_checkout'],
    ['.box-bottom-btn .cms-group-button', null]
  ];

  function buildBox() {
    var label = document.createElement('label');
    label.className = 'mp-b2b';
    label.innerHTML =
      '<input type="checkbox" class="js-mp-b2b">' +
      '<span>Ich bestätige, dass ich als <strong>Unternehmer im Sinne von § 14 BGB</strong> ' +
      '(z.&nbsp;B. Arzt- oder Zahnarztpraxis, Klinik, Labor, Pflegeeinrichtung, Gewerbebetrieb) ' +
      'bestelle und nicht als Verbraucher.</span>' +
      '<em class="mp-b2b__error">Bitte bestätigen Sie, dass Sie als Unternehmer bestellen. ' +
      'Wir liefern ausschließlich an gewerbliche Kunden.</em>';
    label.querySelector('input').checked = confirmed;
    return label;
  }

  function placeBoxes() {
    for (var i = 0; i < SLOTS.length; i++) {
      var hosts = document.querySelectorAll(SLOTS[i][0]);
      for (var j = 0; j < hosts.length; j++) {
        var host = hosts[j];
        var prev = host.previousElementSibling;
        var inside = host.querySelector('.mp-b2b');
        if (inside || (prev && prev.classList.contains('mp-b2b'))) continue;
        var box = buildBox();
        var before = SLOTS[i][1] ? host.querySelector(SLOTS[i][1]) : null;
        if (before) host.insertBefore(box, before);
        else host.parentNode.insertBefore(box, host);
      }
    }
  }

  function stamp() {
    var d = new Date();
    function p(n) { return n < 10 ? '0' + n : String(n); }
    return p(d.getDate()) + '.' + p(d.getMonth() + 1) + '.' + d.getFullYear() +
      ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
  }

  function saveAttribute(confirmed) {
    var body = { attributes: {} };
    body.attributes[KEY] = confirmed
      ? 'Ja – Unternehmer gem. § 14 BGB, bestätigt am ' + stamp()
      : '';
    var note = document.getElementById('CartSpecialInstructions');
    if (note) body.note = note.value;
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function syncBoxes(checked) {
    var boxes = document.querySelectorAll('.js-mp-b2b');
    confirmed = checked;
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].checked = checked;
      var wrap = boxes[i].closest('.mp-b2b');
      if (wrap && checked) wrap.classList.remove('mp-b2b--error');
    }
  }

  function findBox(trigger) {
    var scope = trigger.closest('.box-bottom-btn, .cart-total, form');
    var box = scope ? scope.querySelector('.js-mp-b2b') : null;
    if (box && box.offsetParent !== null) return box;
    return null;
  }

  function go(trigger) {
    var form = trigger.form || trigger.closest('form');
    var isButton = trigger.tagName === 'BUTTON' || trigger.tagName === 'INPUT';
    if (isButton && form) {
      // Original-Formular absenden, damit Mengen und Notiz wie gewohnt
      // uebernommen werden. Shopify leitet bei "checkout" zur Kasse weiter.
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'checkout';
      hidden.value = '1';
      form.appendChild(hidden);
      HTMLFormElement.prototype.submit.call(form);
    } else {
      var href = trigger.getAttribute('href');
      window.location.href = href && href.indexOf('/checkout') !== -1 ? href : '/checkout';
    }
  }

  function proceed(trigger) {
    if (busy) return;
    busy = true;
    saveAttribute(true)
      .catch(function () {})
      .then(function () { go(trigger); });
    setTimeout(function () { busy = false; }, 4000);
  }

  function showError(box) {
    var wrap = box.closest('.mp-b2b');
    if (wrap) {
      wrap.classList.add('mp-b2b--error');
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    box.focus();
  }

  /* ---------- Bestaetigungsfenster fuer Wege ohne Checkbox ---------- */

  function openModal(trigger) {
    var old = document.querySelector('.mp-b2b-modal');
    if (old) old.parentNode.removeChild(old);

    var modal = document.createElement('div');
    modal.className = 'mp-b2b-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'mp-b2b-modal-title');
    modal.innerHTML =
      '<div class="mp-b2b-modal__box">' +
        '<div class="mp-b2b-modal__title" id="mp-b2b-modal-title">Nur für gewerbliche Kunden</div>' +
        '<label class="mp-b2b">' +
          '<input type="checkbox" class="mp-b2b-modal__check">' +
          '<span>' + TEXT + '</span>' +
        '</label>' +
        '<div class="mp-b2b-modal__actions">' +
          '<button type="button" class="mp-b2b-modal__cancel">Abbrechen</button>' +
          '<button type="button" class="mp-b2b-modal__ok" disabled>Weiter zur Kasse</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    var check = modal.querySelector('.mp-b2b-modal__check');
    var ok = modal.querySelector('.mp-b2b-modal__ok');

    function close() {
      if (modal.parentNode) modal.parentNode.removeChild(modal);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    check.addEventListener('change', function () { ok.disabled = !check.checked; });
    ok.addEventListener('click', function () {
      if (!check.checked) return;
      syncBoxes(true);
      proceed(trigger);
    });
    modal.querySelector('.mp-b2b-modal__cancel').addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', onKey);
    check.focus();
  }

  /* ---------- Abfangen aller Wege zur Kasse ---------- */

  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    if (el.closest('.mp-b2b-modal')) return;
    var trigger = el.closest(TRIGGER);
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var box = findBox(trigger);
    if (!box) return openModal(trigger);
    if (!box.checked) return showError(box);
    proceed(trigger);
  }, true);

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.classList || !el.classList.contains('js-mp-b2b')) return;
    syncBoxes(el.checked);
    saveAttribute(el.checked).catch(function () {});
  });

  /* ---------- Start ---------- */

  var placing = null;
  function schedulePlace() {
    clearTimeout(placing);
    placing = setTimeout(placeBoxes, 60);
  }

  function init() {
    placeBoxes();
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var val = cart && cart.attributes ? cart.attributes[KEY] : '';
        syncBoxes(!!val);
      })
      .catch(function () {});
    new MutationObserver(schedulePlace).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
